export enum FULLNAME_LIMIT {
    min = 3,
    max = 40
}